import { render, staticRenderFns } from "./TrackerCarousel.vue?vue&type=template&id=20afbadc"
import script from "./TrackerCarousel.vue?vue&type=script&lang=js"
export * from "./TrackerCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports